<template>
    <v-app id="inspire" class="fill-height">
        <v-main>
            <v-overlay :value="caricamento" z-index="999999999">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <!--<video id="background-video" autoplay loop muted>
                <source
                    src="../assets/Depositphotos_151324262_1080p.mp4"
                    type="video/mp4"
                />
            </video>-->
            <img id="background-img" src="../assets/Ind.jpg" alt="">
            <v-dialog v-model="showDialog" width="60vw">
                <v-card>
                    <v-toolbar color="indigo" dense>
                        <!-- Titolo -->
                        <v-toolbar-title class="white--text">
                            {{(obbligatorio == 0 ? 'Recupero' : 'Cambio') + ' Password'}}
                        </v-toolbar-title>

                        <v-spacer />

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="conferma"
                                >
                                    <v-icon color="success"> mdi-check </v-icon>
                                </v-btn>
                            </template>
                            <span> Conferma </span>
                        </v-tooltip>

                        <v-spacer />

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="chiudi"
                                >
                                    <v-icon color="error"> mdi-close </v-icon>
                                </v-btn>
                            </template>
                            <span> Chiudi </span>
                        </v-tooltip>
                    </v-toolbar>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    label="Username (formato: 'prefisso / nome utente')"
                                    v-model="username"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    label="Email"
                                    v-model="email"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="obbligatorio == 0">
                            <v-col cols="12">
                                <v-text-field
                                    label="Codice di sicurezza"
                                    v-model="code"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="obbligatorio == 1">
                            <v-col cols="12">
                                <v-text-field
                                    label="Password attuale"
                                    v-model="oldpsw"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    label="Nuova password"
                                    v-model="password"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <SnackbarQV ref="SnackbarQV" />
        </v-main>
    </v-app>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
    name: "RecuperoPassword",
    components: {
        SnackbarQV,
    },
    props: {
        obbligatorio: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            caricamento: false,
            showDialog: true,
            username: "",
            email: "",
            code: "",
            password: "",
            oldpsw: ""
        };
    },
    methods: {
        async conferma() {
            this.caricamento = true;
            var request = {
                controller: "Token",
                method: "POST",
                richiesta: {
                    action: "cambiopsw",
                    username: this.username,
                    email: this.email,
                    
                    password: this.password
                },
            };
            if(this.obbligatorio == 1){
                request.richiesta.oldpsw = this.oldpsw;
            }else{
                request.richiesta.codice = this.code;
            }
            await this.$store
                .dispatch("api", request)
                .then((response) => {
                    this.emailRecupero = "";
                    this.dialog_recupero_password = false;

                    if (response.status == "200") {
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Password modificato"
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Impossibile resettare password"
                        );
                    }
                })
                .catch(() => {
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Impossibile resettare password"
                    );
                });
                this.caricamento = false;
        },
        chiudi() {
            this.$router.replace("/login");
        },
    },
};
</script>

<style scoped>
#background-video {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}
</style>
